var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ct-footer',{attrs:{"version":_vm.version,"breakpoint":"is-widescreen"}})
}
var staticRenderFns = []

export { render, staticRenderFns }